import { ViewportScroller } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { appearance } from 'src/app/config/appearance';
import { BaseView } from '../../../../submodules/angular-ui-common/base-view';
import { Color } from 'src/app/config/color';
import { Title, Meta } from '@angular/platform-browser';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseView {

  frontImageLarge="./assets/images/logo.svg";
  bgColor=appearance.publicArea.login.bgColor;
  mobileVersion = false;

  Color = Color

  formSubmitted = false;
  
  constructor(protected _injector: Injector,private title: Title, private meta: Meta) { 
    super(_injector);
    this._injector.get(PageLayoutDataService).init({
      layoutType: 0,
      verticallyCentered:false,
      showBreadcrumbs:false})
  }

  async ngOnInit() {

    //Avendo una sola pagina li riportiamo tutti su index.html

    this.title.setTitle('Performance Training Lab: allenamenti personalizzati in una location esclusiva | Centro Personal Trainer e Pilates a Torino'); 

    this.meta.updateTag(
      {
        name:'description',
        content:`Cerchi uno studio p.t. - fitness e pilates - nel centro di Torino in una location esclusiva? Allora Performance Training Lab, dove personal trainer laureati e qualificati ti seguiranno con l’ausilio di strumenti di monitoraggio e tecniche di ultima generazione nel mondo dello sport e del fitness, è il centro p.t. che fa per te!`
      }); 

    this.meta.updateTag(
      {
        name:'keywords',
        content:'personal trainer torino, personal trainer torino centro, fitness torino, fitness torino centro, studio pt torino, studio pt torino centro, studio p.t. torino, studio p.t. torino centro, pilates torino, pilates torino centro'
      }); 

    this._setSizeBasedProperties()
    if(this.securityDataService.isAuthenticated()) {
      try {
        // await this._injector.get(SecurityDataService).keepSessionAlive()
        // this._router.navigate(['/private/']);
      } catch (error) {
        //NOTHING TO DO
      }
    }

    this._injector.get(PageLayoutDataService).loading = false;
  }

  onResize = (event) => this._setSizeBasedProperties()

  _setSizeBasedProperties = () => {
    if(this.isLesserThanM) {
      this.mobileVersion = true;
    } else {
      this.mobileVersion = false;
    }
  }

  // accedi(){
  //   this._router.navigate(['/private/']);
  // }

  goHere() {
    try {
      this._injector.get(ViewportScroller).scrollToAnchor('services');
    } catch (error) {
      console.log('error :>> ', error);
    }
  }

  manageSuccessfulSubmit(){

    console.log('manageSuccessfulSubmit :>> ', this.formSubmitted);
    this.formSubmitted = true;
    console.log('manageSuccessfulSubmit :>> ', this.formSubmitted);
  }
}
